import { Link, Box } from '@mui/material';
import "./ForwardLink.scss";

const ForwardLink = ({ url, text, arrowColor, action, sameTab}) => {
  const forwardArrow = arrowColor === 'white' ? require('../../../img/forward-arrow-white.png') : require('../../../img/forward-arrow-blue.png');
  const target = sameTab ? '_self' : '_blank';

  return (
    <Box className='forwardLink'>
      <Link
        href={url}
        className='forward-link'
        target={target}
        onClick={action}
      >
        <span className='forward-link-text'>{text}</span>
        <img
          src={forwardArrow}
          alt='forward'
          width='24px'
          height='24px'/>
       </Link>
     </Box>
  );
};

export default ForwardLink;